import React from 'react';
import T from 'prop-types';

import Navbar from '../../components/navbar';
import Footer from '../../components/footer';

import { Layout } from '../style';

import { Container } from './style';

interface NarrowProps {
  children: React.ReactNode;
}

const Narrow: React.FC<NarrowProps> = ({ children }) => (
  <>
    <Navbar />
    <Layout>
      <Layout.Content>
        <Container>{children}</Container>
      </Layout.Content>
      <Footer />
    </Layout>
  </>
);

Narrow.propTypes = {
  children: T.node.isRequired,
};

export default Narrow;
